import { useGetRequest } from "hooks/utils/useGetRequest";
import { CreatedInterfaces } from "interfaces";

const resource = 'claims-comment-paginated';

const useGetClaimComments = (id: string, pageIndex: number, pageSize: number) => {
  const [{ data, error, loading }, executeGetClaimComments] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/claims/${id}/comments?size=${pageSize}&page=${pageIndex}&sort=id`,
  });

  
  return {
    comments:  data?.data,
    pageInfo: data?.meta,
    isLoading: loading,
    isError: error,
    executeGetClaimComments: executeGetClaimComments
  };
};

export default useGetClaimComments;
  